import React, { useState } from 'react';
import style from './userDataProfileContainer.module.css';
import ProfileEditForm from './EditForm/ProfileEditForm.jsx';
import UserDataProfile from './UserDataProfile.jsx';

const UserDataProfileContainer = (props) => {
    const [editMode, setEdit] = useState(false);
    const editHandler = () => {
        setEdit(editMode => editMode = true);
    }
    return (
        <div className={style["user-data"]}>
            {editMode
                ? <ProfileEditForm data={props} setEdit={setEdit}/>
                : <UserDataProfile {...props}
                    editHandler={editHandler} />}
        </div>
    )
};

export default UserDataProfileContainer;